var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIconsCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.433,
    height: 16.505,
    viewBox: "0 0 21.433 16.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.57-17.088-15.9-4.757-20.43-9.288a.563.563,0,0,0-.8,0l-1.326,1.326a.563.563,0,0,0,0,.8L-16.3-.912a.563.563,0,0,0,.8,0L-1.448-14.966a.562.562,0,0,0,0-.8l-1.326-1.326A.563.563,0,0,0-3.57-17.088Z",
    transform: "translate(22.716 17.252)",
    fill: "#fdba30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconsCheck);
export default __webpack_public_path__ + "static/media/generalIcons_Check.84d2cbdddd841e3a0ff59dd55f010f2b.svg";
export { ForwardRef as ReactComponent };